import React, { useState } from "react";
import Header from "../_components/_global/WelcomeHeader";
import { 
  Mail, 
  Headphones, 
  Users, 
  MapPin, 
  Clock, 
  Send,
  Phone,
  Globe,
  ArrowRight,
  ChevronDown
} from "lucide-react";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    topic: '',
    message: ''
  });
  const [agreed, setAgreed] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    console.log('Form submitted:', formData);
  };

  return (
    <>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        body {
          font-family: "Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif;
          background: #ffffff;
          color: #1a1a1a;
        }
        
        .contact-container {
          min-height: 100vh;
          background: #ffffff;
          padding-top: 80px;
        }
        
        .contact-content {
          max-width: 1200px;
          margin: 0 auto;
          padding: 60px 20px;
        }
        
        /* Hero Section */
        .contact-hero {
          text-align: center;
          margin-bottom: 60px;
        }
        
        .contact-title {
          font-size: 56px;
          font-weight: 600;
          color: #0f1720;
          margin-bottom: 20px;
          line-height: 1.2;
        }
        
        .contact-subtitle {
          font-size: 18px;
          color: #6b7280;
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }
        
        /* Contact Cards */
        .contact-cards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 32px;
          max-width: 900px;
          margin: 0 auto 80px;
        }
        
        .contact-card {
          text-align: center;
          padding: 32px;
          background: #f9fafb;
          border-radius: 12px;
          transition: all 0.3s ease;
          border: 1px solid transparent;
        }
        
        .contact-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          border-color: #e5e7eb;
          background: #ffffff;
        }
        
        .contact-icon-wrapper {
          width: 56px;
          height: 56px;
          margin: 0 auto 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: white;
          border-radius: 12px;
          color: #3b82f6;
          transition: all 0.3s;
        }
        
        .contact-card:hover .contact-icon-wrapper {
          background: #3b82f6;
          color: white;
        }
        
        .contact-label {
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
          margin-bottom: 8px;
        }
        
        .contact-email {
          font-size: 15px;
          color: #4b5563;
          text-decoration: none;
          margin-bottom: 8px;
          display: block;
          transition: color 0.2s;
        }
        
        .contact-email:hover {
          color: #3b82f6;
        }
        
        .contact-time {
          font-size: 13px;
          color: #9ca3af;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          margin-top: 12px;
        }
        
        .time-icon {
          color: #10b981;
        }
        
        /* Main Content Grid */
        .contact-main {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          max-width: 1000px;
          margin: 0 auto;
        }
        
        /* Form Section */
        .form-section {
          padding-right: 20px;
        }
        
        .section-title {
          font-size: 28px;
          font-weight: 600;
          color: #0f1720;
          margin-bottom: 12px;
        }
        
        .section-description {
          font-size: 15px;
          color: #6b7280;
          margin-bottom: 32px;
          line-height: 1.6;
        }
        
        .form-group {
          margin-bottom: 24px;
        }
        
        .form-label {
          display: block;
          font-size: 14px;
          font-weight: 500;
          color: #374151;
          margin-bottom: 8px;
        }
        
        .form-input {
          width: 100%;
          padding: 10px 14px;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          font-size: 15px;
          color: #1f2937;
          background: #ffffff;
          transition: all 0.2s;
        }
        
        .form-input:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }
        
        .form-input::placeholder {
          color: #9ca3af;
        }
        
        .form-select-wrapper {
          position: relative;
        }
        
        .form-select {
          width: 100%;
          padding: 10px 40px 10px 14px;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          font-size: 15px;
          color: #1f2937;
          background: white;
          cursor: pointer;
          transition: all 0.2s;
          appearance: none;
        }
        
        .form-select:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }
        
        .select-icon {
          position: absolute;
          right: 14px;
          top: 50%;
          transform: translateY(-50%);
          pointer-events: none;
          color: #6b7280;
        }
        
        .form-textarea {
          width: 100%;
          padding: 10px 14px;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          font-size: 15px;
          color: #1f2937;
          background: #ffffff;
          resize: vertical;
          min-height: 120px;
          font-family: "Segoe UI", sans-serif;
          transition: all 0.2s;
        }
        
        .form-textarea:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }
        
        .form-checkbox-group {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          margin-bottom: 24px;
        }
        
        .form-checkbox {
          width: 18px;
          height: 18px;
          margin-top: 2px;
          cursor: pointer;
          accent-color: #3b82f6;
        }
        
        .checkbox-label {
          font-size: 14px;
          color: #4b5563;
          line-height: 1.5;
        }
        
        .checkbox-label a {
          color: #3b82f6;
          text-decoration: none;
        }
        
        .checkbox-label a:hover {
          text-decoration: underline;
        }
        
        .submit-btn {
          width: 100%;
          padding: 12px 24px;
          background: #10b981;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }
        
        .submit-btn:hover {
          background: #059669;
          transform: translateY(-1px);
        }
        
        .submit-btn:disabled {
          background: #d1d5db;
          cursor: not-allowed;
          transform: none;
        }
        
        /* Office Info Section */
        .info-section {
          padding-left: 20px;
        }
        
        .info-block {
          margin-bottom: 40px;
        }
        
        .info-item {
          display: flex;
          align-items: flex-start;
          gap: 16px;
          margin-bottom: 24px;
          padding: 20px;
          background: #f9fafb;
          border-radius: 12px;
          transition: all 0.2s;
        }
        
        .info-item:hover {
          background: #f3f4f6;
        }
        
        .info-icon {
          width: 40px;
          height: 40px;
          color: #3b82f6;
          background: white;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        
        .info-content {
          flex: 1;
        }
        
        .info-title {
          font-size: 16px;
          font-weight: 600;
          color: #1f2937;
          margin-bottom: 4px;
        }
        
        .info-text {
          font-size: 14px;
          color: #6b7280;
          line-height: 1.6;
        }
        
        /* Map */
        .map-container {
          width: 100%;
          height: 250px;
          background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #9ca3af;
          font-size: 14px;
          margin-bottom: 32px;
          position: relative;
          overflow: hidden;
          border: 1px solid #e5e7eb;
        }
        
        .map-placeholder {
          text-align: center;
        }
        
        .map-icon {
          color: #9ca3af;
          margin-bottom: 8px;
        }
        
        /* Contact Methods */
        .contact-methods {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-top: 32px;
        }
        
        .method-card {
          padding: 16px;
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          display: flex;
          align-items: center;
          gap: 12px;
          transition: all 0.2s;
          cursor: pointer;
        }
        
        .method-card:hover {
          border-color: #3b82f6;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        }
        
        .method-icon {
          color: #6b7280;
        }
        
        .method-text {
          font-size: 14px;
          color: #4b5563;
        }
        
        /* Quick Links */
        .quick-links {
          border-top: 1px solid #e5e7eb;
          padding-top: 32px;
        }
        
        .quick-links-title {
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
          margin-bottom: 16px;
        }
        
        .quick-links-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        
        .quick-link {
          color: #4b5563;
          text-decoration: none;
          font-size: 14px;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          transition: all 0.2s;
        }
        
        .quick-link:hover {
          color: #3b82f6;
          gap: 12px;
        }
        
        /* Responsive */
        @media (max-width: 768px) {
          .contact-title {
            font-size: 36px;
          }
          
          .contact-cards {
            grid-template-columns: 1fr;
            gap: 20px;
          }
          
          .contact-main {
            grid-template-columns: 1fr;
            gap: 60px;
          }
          
          .form-section {
            padding-right: 0;
          }
          
          .info-section {
            padding-left: 0;
          }
          
          .contact-methods {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <Header />
      
      <div className="contact-container">
        <div className="contact-content">
          {/* Hero Section */}
          <div className="contact-hero">
            <h1 className="contact-title">Get in touch</h1>
            <p className="contact-subtitle">
              Have a question or feedback? We'd love to hear from you. Our team typically responds within 24 hours.
            </p>
          </div>

          {/* Contact Cards */}
          <div className="contact-cards">
            <div className="contact-card">
              <div className="contact-icon-wrapper">
                <Mail size={24} />
              </div>
              <div className="contact-label">General Inquiries</div>
              <a href="mailto:hello@citygetaway.com" className="contact-email">
                hello@citygetaway.com
              </a>
              <div className="contact-time">
                <Clock size={14} className="time-icon" />
                <span>Response within 24 hours</span>
              </div>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon-wrapper">
                <Headphones size={24} />
              </div>
              <div className="contact-label">Support</div>
              <a href="mailto:support@citygetaway.com" className="contact-email">
                support@citygetaway.com
              </a>
              <div className="contact-time">
                <Clock size={14} className="time-icon" />
                <span>Response within 12 hours</span>
              </div>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon-wrapper">
                <Users size={24} />
              </div>
              <div className="contact-label">Partnerships</div>
              <a href="mailto:partnerships@citygetaway.com" className="contact-email">
                partnerships@citygetaway.com
              </a>
              <div className="contact-time">
                <Clock size={14} className="time-icon" />
                <span>Response within 48 hours</span>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="contact-main">
            {/* Form Section */}
            <div className="form-section">
              <h2 className="section-title">Send us a message</h2>
              <p className="section-description">
                Fill out the form below and we'll get back to you as soon as possible
              </p>

              <div className="form-group">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-input"
                  placeholder="John Doe"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-input"
                  placeholder="john@example.com"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Topic</label>
                <div className="form-select-wrapper">
                  <select 
                    name="topic"
                    className="form-select"
                    value={formData.topic}
                    onChange={handleInputChange}
                  >
                    <option value="">Select a topic</option>
                    <option value="general">General Inquiry</option>
                    <option value="support">Technical Support</option>
                    <option value="billing">Billing Question</option>
                    <option value="partnership">Partnership Opportunity</option>
                    <option value="feedback">Product Feedback</option>
                    <option value="other">Other</option>
                  </select>
                  <ChevronDown size={20} className="select-icon" />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Message</label>
                <textarea
                  name="message"
                  className="form-textarea"
                  placeholder="Tell us more about your inquiry..."
                  value={formData.message}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-checkbox-group">
                <input
                  type="checkbox"
                  id="agreement"
                  className="form-checkbox"
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                />
                <label htmlFor="agreement" className="checkbox-label">
                  I agree to the <a href="#">Privacy Policy</a> and consent to CityGetAway storing my submitted information
                </label>
              </div>

              <button 
                className="submit-btn" 
                disabled={!agreed}
                onClick={handleSubmit}
              >
                Send Message
                <Send size={18} />
              </button>
            </div>

            {/* Office Info Section */}
            <div className="info-section">
              <h2 className="section-title">Office Information</h2>
              
              <div className="map-container">
                <div className="map-placeholder">
                  <MapPin size={48} className="map-icon" />
                  <div>Map view</div>
                </div>
              </div>

              <div className="info-block">
                <div className="info-item">
                  <div className="info-icon">
                    <MapPin size={20} />
                  </div>
                  <div className="info-content">
                    <div className="info-title">Headquarters</div>
                    <div className="info-text">
                      123 Travel Street<br />
                      San Francisco, CA 94102<br />
                      United States
                    </div>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <Clock size={20} />
                  </div>
                  <div className="info-content">
                    <div className="info-title">Timezone</div>
                    <div className="info-text">
                      Pacific Time (PT)<br />
                      Mon-Fri: 9:00 AM - 6:00 PM
                    </div>
                  </div>
                </div>
              </div>

              <div className="contact-methods">
                <div className="method-card">
                  <Phone size={18} className="method-icon" />
                  <span className="method-text">+1 (555) 123-4567</span>
                </div>
                <div className="method-card">
                  <Globe size={18} className="method-icon" />
                  <span className="method-text">citygetaway.com</span>
                </div>
              </div>

              <div className="quick-links">
                <h3 className="quick-links-title">Quick Links</h3>
                <div className="quick-links-list">
                  <a href="#" className="quick-link">
                    FAQ
                    <ArrowRight size={14} />
                  </a>
                  <a href="#" className="quick-link">
                    Pricing
                    <ArrowRight size={14} />
                  </a>
                  <a href="#" className="quick-link">
                    Status Page
                    <ArrowRight size={14} />
                  </a>
                  <a href="#" className="quick-link">
                    API Documentation
                    <ArrowRight size={14} />
                  </a>
                  <a href="#" className="quick-link">
                    Terms of Service
                    <ArrowRight size={14} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;